<template src="@/templates/interpreterPromoteCarousel.html"></template>

<script>
	import IntPromotedCarouselCollection from "@/collections/intPromotedCarouselCollection"
	
	export default {
		name: "InterpreterPromoteCarousel",
		data() {
			return {
				intPromotedCarouselCollection: new IntPromotedCarouselCollection(),
			}
		},
		created() {
			this.loadPromotedInterpreters();
		},
		methods: {
			loadPromotedInterpreters() {
				let url = this.$localApiURL + this.intPromotedCarouselCollection.getRoute("fetch") + "?token=" + localStorage.getItem('jwt');
				this.$http.get(url).
				then((res) => {

					this.intPromotedCarouselCollection.models = res.data.data;
					
				}).catch((error) => {
					console.error(error);
				});
			},
			getImage( interpreter_id ) {
				return this.$publicApiURL + 'interpreter/' + interpreter_id + '/photo/get?token=' + localStorage.getItem('jwt')
			}
		}
	}
</script>

<style scoped>
	
	.el-carousel {
		height: inherit !important;
	}
	
	.card-body {
		height: inherit !important;
	}
	
	.card-body >>> .el-carousel__button {
		background: #e8882f !important;
		width: 4px !important;
		height: 4px !important;
	}
	
	.card-body >>> .el-carousel__item.is-active {
		z-index: 0 !important;
	}
	
	.card-body >>> .el-carousel__indicators {
		z-index: 0 !important;
		width: fit-content !important;
	}
	
	.card-body >>> .el-carousel__indicator {
		padding: 0 4px !important;
	}
	
	.card-body >>> .bg-warning {
		background-color: #dee2e6 !important;
	}
	
	.card-body >>> .el-carousel__container {
		height: calc(100vh - 150px) !important;
	}
</style>

<style scoped lang="scss">
	
	.el-carousel__container {
		$filterOption: 63px;
		$tableHeader-margin: 25px;
		$tableHeader: 58px;
		$pagination: 50px;
		
		$total: calc(#{$filterOption} + #{$tableHeader-margin} + #{$tableHeader} + #{$pagination});
		
		height: calc(100vh - #{$total}) !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/InterpreterPromoteCarousel.vue